import { memo, useState } from "react";
import { ChevronDown } from "lucide-react";

const FormMultiSelect = ({ label, options = [], value = [], onChange }) => {
  const [open, setOpen] = useState(false);

  const toggleOption = (id) => {
    if (value.includes(id)) {
      onChange(value.filter((item) => item !== id));
    } else {
      onChange([...value, id]);
    }
  };

  return (
    <div className="relative">
      <label className="text-sm text-slate-300">{label}</label>

      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full mt-2 border border-white/10 bg-white/5 rounded-xl px-4 py-3 flex justify-between items-center"
      >
        <span>
          {value.length ? `${value.length} Selected` : `Select ${label}`}
        </span>

        <ChevronDown size={18} />
      </button>

      {open && (
        <div className="absolute mt-2 w-full rounded-xl bg-[#111827] border border-white/10 max-h-60 overflow-y-auto z-50">
          {options.map((item) => (
            <label
              key={item.value}
              className="flex items-center gap-3 px-4 py-3 hover:bg-white/5 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={value.includes(item.value)}
                onChange={() => toggleOption(item.value)}
              />

              {item.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(FormMultiSelect);
